import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import I18n from 'i18n-js';

import EditOrderModal from '../../../components/customer-po/EditOrderModal';

import * as selectors from '../../../../selectors/customer-po/current/createOrder';
import * as actions from '../../../../actions/customer-po/current/createOrder';


class CreateOrderModal extends Component {
  componentWillMount() {
    this.props.loadData();
  }

  render() {
    return (
      <EditOrderModal
        title={I18n.t('PageOrder.ADDORDER')}
        {...this.props}
        onSubmitClick={() => this.props.submitOrder(this.props.fnBody())}
      />
    )
  }
}

const mapStateToProps = state => ({
  isOpen: selectors.isOpen(state),
  customerPO: selectors.getCustomerPO(state),
  orderDate: selectors.getOrderDate(state),
  exFactory: selectors.getExFactory(state),
  ihDate: selectors.getIhDate(state),
  description: selectors.getDescription(state),
  selectableCustomers: selectors.getSelectableCustomers(state),
  selectedCustomer: selectors.getSelectedCustomer(state),

  errors: selectors.getErrors(state),
  canSave: selectors.canSave(state),
  submiting: selectors.isSubmiting(state),
  fnBody: selectors.fnGenerateRequestBody(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadData() {
    dispatch(actions.listSelectableCustomers());
    dispatch(actions.listValidateOrderNames());
  },

  onCloseClick() {
    dispatch(actions.hideModal());
  },

  submitOrder(order) {
    dispatch(actions.submitOrder(order));
  },

  onChangeSelectedCustomer(item) {
    dispatch(actions.changeSelectedCustomer(item ? item.raw : null));
  },

  onChangeCustomerPO(value) {
    dispatch(actions.changeCustomerPO(value));
  },

  onChangeOrderDate(value) {
    dispatch(actions.changeOrderDate(value));
  },

  onChangeExFactory(value) {
    dispatch(actions.changeExFactory(value));
  },

  onChangeIhDate(value) {
    dispatch(actions.changeIhDate(value));
  },

  onChangeDescription(value) {
    dispatch(actions.changeDescription(value));
  },

});

export default connect(mapStateToProps, mapDispatchToProps) (withRouter(CreateOrderModal));
